import React from 'react';
import './styles/Table.css';
import { Grid } from '@mui/material';
import _ from 'lodash';

const DailySeatTable = (props) => {
  const widthRate = props.widthRate != null ? parseFloat(props.widthRate) : 1.2;
  if (props.json == null) {
    return <Grid item xs={widthRate == null ? 1.2 : widthRate} />;
  }
  const json = props.json;

  const tbodies2 = json.map((seat, i) => {
    return (
      <tr key={i}>
        <td
          style={{
            backgroundColor: '#ddd',
            color: 'black',
            fontWeight: 'normal',
            fontSize: '10px',
            borderCollapse: 'collapse',
            width: '20px',
          }}
        >
          {seat.seatNo}
        </td>

        <td
          style={{
            backgroundColor:
              seat.status === 0
                ? ''
                : seat.status === 1
                  ? '#99bd89' //YESIL
                  : seat.status === 2
                    ? '#DD5746' //KIRMIZI
                    : seat.status === 3
                      ? ''
                      : '',
            color: seat.status === 2 ? 'white' : 'black',
            fontWeight: seat.status === 0 ? 'normal' : 'normal',
            fontSize: '10px',
            borderCollapse: 'collapse',
            width: '25px',
          }}
        >
          {seat.status === 0
            ? ''
            : seat.status === 1 || seat.status === 2
              ? '%' + seat.score
              : seat.status == 3
                ? ''
                : ''}
        </td>
      </tr>
    );
  });

  const seatCount = json.length; // Count of seats
  let columnCount;

  if (seatCount <= 20) {
    columnCount = 2;
  } else if (seatCount <= 30) {
    columnCount = 3;
  } else {
    columnCount = 4;
  }

  // Split the table rows based on the column count
  const columns = _.chunk(tbodies2, Math.ceil(tbodies2.length / columnCount));

  // Create table columns dynamically based on the column count
  const tableColumns = columns.map((column, index) => (
    <td key={index}>
      <table>
        <tbody>{column}</tbody>
      </table>
    </td>
  ));

  return (
    <Grid>
      <table
        style={{
          backgroundColor: '#e0e0e0',
          borderCollapse: 'collapse',
        }}
      >
        {/* <thead>
                    <tr>
                        <th
                            colSpan={columnCount}
                            style={{
                                textAlign: 'center',
                                fontWeight: 'bold',
                            }}
                        >
                            Koltuk
                        </th>
                    </tr>
                </thead> */}
        <tbody>
          <tr>{tableColumns}</tr>
        </tbody>
      </table>
    </Grid>
  );
};

export default DailySeatTable;
